import App from './App';

import Home from './pages/home';
import Chain from './pages/chain';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    component: App,
    routes: [
      {
        path: '/',
        exact: true,
        component: Home,
      },
      {
        path: '/chain',
        exact: true,
        authentication: true,
        component: Chain,
      },
      {
        path: '*',
        component: Home,
      },
    ],
  },
];
  